exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nfigure[data-v-2de3155c]{display:inline-block;text-align:center\n}\n", ""]);

// exports
